import { formulaParser } from '../lezer-syntax-parser';
import { possibleVariablePatterns } from '../tokens';

export interface FormulaContext {
  indexers?: string[];
  variableName?: string;

  functionName?: string;
  parameterIndex?: number;

  contextTokenType?: string;
  phrase: string;
}

export const extractIndices = (variable: string): string[] => {
  const regex = /\[(.*?)]/g;
  let match: RegExpExecArray | null;
  const indices = [];
  while ((match = regex.exec(variable)) !== null) {
    const value = match[1];
    indices.push(JSON.parse(value));
  }
  return indices;
};

export const getFormulaContext = (codeText: string): FormulaContext => {
  const regex = /^(.*?)([a-z A-Z0-9_-]*)$/;

  let cleanedCode = codeText;
  possibleVariablePatterns.forEach((pattern) => {
    const regex = new RegExp(pattern, 'g');
    cleanedCode = cleanedCode.replaceAll(regex, '');
  });
  const match = regex.exec(cleanedCode);
  let searchPhrase = match ? match[2] : '';
  searchPhrase = searchPhrase.trimStart();
  const contextCode = codeText.slice(0, codeText.length - searchPhrase.length);

  const tree = formulaParser.parse(contextCode);
  const cursor = tree.cursor();
  cursor.moveTo(contextCode.length - 1);
  const possibleContexts = ['VariableName', 'FunctionCall'];

  do {
    if (possibleContexts.includes(cursor.name)) {
      break;
    }
  } while (cursor.parent());

  const result = {
    phrase: searchPhrase,
  };

  const contextToken = codeText.slice(cursor.node.from, cursor.node.to);
  if (cursor.name === 'VariableName') {
    const indexers = extractIndices(contextToken);
    return { ...result, contextTokenType: 'VariableName', variableName: contextToken, indexers };
  }
  if (cursor.name === 'FunctionCall') {
    const isInsideBrackets = contextToken?.includes('(') && !contextToken?.endsWith(')');
    if (!isInsideBrackets) {
      return result;
    }

    const previousParameters = cursor.node.getChildren('Expression');

    const functionNameNode = cursor.node.getChild('FunctionName');
    const functionName = functionNameNode
      ? codeText.slice(functionNameNode.from, functionNameNode.to)
      : '';
    return {
      ...result,
      functionName: functionName,
      parameterIndex: previousParameters.length,
      contextTokenType: 'FunctionCall',
    };
  }
  return result;
};
